import { MessageMedium, WhatsAppMedium } from 'constants/messageMediums';
import styled from 'styled-components';
import { EmptyStateFind, EmptyStateWhatsAppChannels } from 'ui/illustrations';
import { EmptyState } from 'ui/emptyState';
import { colors, smallShadow, spacing, WebLink } from 'ui/theme';
import { getLabelByMedium } from 'utils/messageMediums';
import { SUPPORT_LINKS } from '../constants';

const StyledCard = styled.div`
  padding: ${spacing.double};
  background-color: ${colors.white};
  border: ${spacing.single} solid ${colors.grey5};
  border-radius: ${spacing.half};
  ${smallShadow}
`;

export const TEXT = {
  TITLE: 'Time to add your first subscription channel',
  SUPPORT_TEXT_PREFIX: (
    <>
      To create your first subscription channel, you must set up a{' '}
      <WebLink href="/settings/sendingPlatforms">sending platform</WebLink> first.
    </>
  ),
};

const Subtitle = ({
  medium,
  hasEspAccounts,
}: {
  medium: MessageMedium | WhatsAppMedium | undefined;
  hasEspAccounts?: boolean;
}) => {
  if (!medium) return <>{TEXT.SUPPORT_TEXT_PREFIX}</>;

  const label = getLabelByMedium(medium);
  const href = SUPPORT_LINKS?.[medium];
  if (medium === WhatsAppMedium.WhatsApp && hasEspAccounts) {
    return (
      <>
        Click on “New subscription channel” to get started.
        {/* For more help, see our WhatsApp Setup
        guide. */}
      </>
    );
  }
  if (!label || !href) {
    return <>{TEXT.SUPPORT_TEXT_PREFIX}</>;
  }

  return (
    <>
      {TEXT.SUPPORT_TEXT_PREFIX} For more help, see our{' '}
      <WebLink href={href} target="_blank" rel="noopener noreferrer">
        {label} setup
      </WebLink>{' '}
      guide.
    </>
  );
};

export type Props = {
  messageMedium: MessageMedium | WhatsAppMedium | undefined;
  hasEspAccounts?: boolean;
};

export const EmptyChannelCard = ({ messageMedium, hasEspAccounts }: Props) => {
  return (
    <StyledCard data-testid={`empty-channel-${messageMedium || 'unknown'}`}>
      <EmptyState
        Illustration={
          messageMedium !== WhatsAppMedium.WhatsApp ? EmptyStateFind : EmptyStateWhatsAppChannels
        }
        title={TEXT.TITLE}
        subtitle={<Subtitle medium={messageMedium} hasEspAccounts={hasEspAccounts} />}
      />
    </StyledCard>
  );
};
